// Маппинг технических адресов на реальные адреса с координатами
// Формат: "техническийАдрес": { address: "Человеческий адрес", coordinates: [широта, долгота] }
// Автоматически сгенерировано: 2025-10-19 15:37:17
// Всего адресов: 156

export const addressMapping = {
  // Пример заполнения (можете удалить после заполнения своих данных)
  '1234_Москва_ул_Ленина_1': {
    address: 'Москва, ул. Ленина, д. 1',
    coordinates: [55.751244, 37.618423], // Координаты можно найти на Яндекс.Картах
  },

  // ========== Адреса из базы данных (требуют заполнения) ==========
  '1031М_Хорошевское68': {
    address: 'Хорошёвское шоссе, 68', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.778051, 37.526528], // TODO: Укажите [широта, долгота]
  },
  '123_Тест': {
    address: 'улица Галины Вишневской, 8к1, Видное', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.536517, 37.645528], // TODO: Укажите [широта, долгота]
  },
  '1584М_Сол_Дзержинского15': {
    address: 'улица Дзержинского, 15, Солнечногорск', // TODO: Укажите человекочитаемый адрес
    coordinates: [56.186895, 36.98302], // TODO: Укажите [широта, долгота]
  },
  '2989М_Ярцевская34': {
    address: 'Ярцевская улица, 34, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.742093, 37.41873], // TODO: Укажите [широта, долгота]
  },
  '3072М_БольшаяСпасская8': {
    address: 'Большая Спасская улица, 8, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.775854, 37.64418], // TODO: Укажите [широта, долгота]
  },
  '4723ДС_Мос_Солнечная3': {
    address: 'Солнечная улица, 3Ас1, Московский, Филимонковский район, Новомосковский административный округ, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.590796, 37.366942], // TODO: Укажите [широта, долгота]
  },
  '4743ДС_Киевская27': {
    address: 'Киевская улица, 27, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.737258, 37.540497], // TODO: Укажите [широта, долгота]
  },
  '4747 ДС_ Пуш_Яраславское190': {
    address: 'Ярославское шоссе, 190к1, Пушкино', // TODO: Укажите человекочитаемый адрес
    coordinates: [56.003542, 37.876772], // TODO: Укажите [широта, долгота]
  },
  '4755ДС_Пятницкое29': {
    address: 'Пятницкое шоссе, 29, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.850661, 37.364571], // TODO: Укажите [широта, долгота]
  },
  '4779ДС_Бал_Носовихинское4': {
    address: 'Носовихинское шоссе, вл4, микрорайон Салтыковка, Балашиха', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.749674, 37.888522], // TODO: Укажите [широта, долгота]
  },

  '4781ДС_Бал_Промышленная49': {
    address: 'Промышленная улица, 49, микрорайон Саввино, Балашиха', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.723506, 38.017772], // TODO: Укажите [широта, долгота]
  },
  '4785ДС_Солнечногорская4': {
    address: 'Солнечногорская улица, 4, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.856518, 37.515811], // TODO: Укажите [широта, долгота]
  },
  '4786ДС_Борисовскиепруды8': {
    address: 'улица Борисовские Пруды, 8А', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.635081, 37.736428], // TODO: Укажите [широта, долгота]
  },
  '4795ДС_Шолохова19': {
    address: 'улица Шолохова, 19А, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.643043, 37.343236], // TODO: Укажите [широта, долгота]
  },
  '4799ДС_Речников17': {
    address: 'улица Речников, 17к1, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.681326, 37.692384], // TODO: Укажите [широта, долгота]
  },
  '4801ДС_Походный5': {
    address: 'Походный проезд, 5, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.836929, 37.411427], // TODO: Укажите [широта, долгота]
  },
  '4811ДС_Миклухо-Маклая40': {
    address: 'улица Миклухо-Маклая, 40, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.638302, 37.539473], // TODO: Укажите [широта, долгота]
  },
  '4815ДС_Один_Транспортная2': {
    address: 'Транспортная улица, 2, Одинцово', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.671691, 37.292849], // TODO: Укажите [широта, долгота]
  },
  '4827ДС_Пермская1': {
    address: 'Пермская улица, 1с1, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.820941, 37.748475], // TODO: Укажите [широта, долгота]
  },
  '4835ДС_ЛефортовскийВал': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '4835ДС_Лефортовский Вал 26': {
    address: 'улица Лефортовский Вал, 26/3Ас3, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.756903, 37.694944], // TODO: Укажите [широта, долгота]
  },
  '4900ДС_Пришвина 3Г': {
    address: 'улица Пришвина, 3Г, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.889926, 37.594279], // TODO: Укажите [широта, долгота]
  },
  '4908ДС_Бал_Советская36': {
    address: 'Советская улица, 36, Балашиха', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.81391, 37.954989], // TODO: Укажите [широта, долгота]
  },
  '4969ДС_Дол_Транспортный11': {
    address: 'Транспортный проезд, 11, Долгопрудный', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.91629, 37.503522], // TODO: Укажите [широта, долгота]
  },
  '5005ДС_Кутузовский88': {
    address: 'Кутузовский проспект, 88, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.725595, 37.449677], // TODO: Укажите [широта, долгота]
  },
  '5017ДС_Нагорная37': {
    address: 'Нагорная улица, 37, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.670295, 37.593156], // TODO: Укажите [широта, долгота]
  },
  '5104ДС_Под_Комсомольская28': {
    address: 'Комсомольская улица, 28, Подольск', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.428904, 37.556011], // TODO: Укажите [широта, долгота]
  },
  '5339ДС_Ист_Урицкого86': {
    address: 'улица Урицкого, 86, Истра', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.92547, 36.866015], // TODO: Укажите [широта, долгота]
  },
  '5366ДС_Жук_Королева5': {
    address: 'улица Королёва, 5, Жуковский', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.609741, 38.09588], // TODO: Укажите [широта, долгота]
  },
  '5411ДС_СПос_Стахановская1': {
    address: 'Стахановская улица, 1Г, Сергиев Посад', // TODO: Укажите человекочитаемый адрес
    coordinates: [56.317003, 38.154621], // TODO: Укажите [широта, долгота]
  },

  '5467ДС_Зве_Пролетарская53': {
    address: 'Пролетарская улица, 53, Звенигород', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.742585, 36.860616], // TODO: Укажите [широта, долгота]
  },
  '5469ДС_Дубнинская83': {
    address: 'Дубнинская улица, 83, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.89346, 37.556334], // TODO: Укажите [широта, долгота]
  },
  '5508ДС_Ставрапольская 41': {
    address: 'Ставропольская улица, 41, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.682173, 37.779314], // TODO: Укажите [широта, долгота]
  },
  '5517ДС_Рам_Михалевича71': {
    address: 'улица Михалевича, 71, Раменское', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.55832, 38.255924], // TODO: Укажите [широта, долгота]
  },
  '5531ДС_ГенералаБелова26': {
    address: 'улица Генерала Белова, 26, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.606136, 37.723268], // TODO: Укажите [широта, долгота]
  },
  '5562ДС_1йДорожный1': {
    address: '1-й Дорожный проезд, 1, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.616961, 37.614132], // TODO: Укажите [широта, долгота]
  },
  '5563ДС_Волынская10': {
    address: 'Волынская улица, 10, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.64351, 37.411256], // TODO: Укажите [широта, долгота]
  },
  '5591ДС_Тре_Трехгорная12': {
    address: 'Трёхгорная улица, 12, посёлок Трёхгорка', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.698416, 37.338825], // TODO: Укажите [широта, долгота]
  },
  '5656ДС_Тро_Фабричная1': {
    address: 'Фабричная площадь, 1, Троицк', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.493295, 37.307339], // TODO: Укажите [широта, долгота]
  },

  '5668ДС_Лесноррядская10': {
    address: 'Леснорядская улица, 10с1', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.781641, 37.675181], // TODO: Укажите [широта, долгота]
  },
  '5686ДС_Лоб_Маяковского5': {
    address: 'улица Маяковского, 5, Лобня, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [56.012486, 37.484415], // TODO: Укажите [широта, долгота]
  },
  '5689ДС_Воротынская2': {
    address: 'Воротынская улица, 2, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.887392, 37.402686], // TODO: Укажите [широта, долгота]
  },
  '5791ДС_Новоясеневский8': {
    address: 'Новоясеневский проспект, 8с1, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.612507, 37.515344], // TODO: Укажите [широта, долгота]
  },
  '5814ДС_Алтуфьевское22': {
    address: 'Алтуфьевское шоссе, 22, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.859266, 37.585583], // TODO: Укажите [широта, долгота]
  },
  '5818ДС_ОлимпийскаяДеревня4': {
    address: 'улица Мичуринский Проспект, Олимпийская Деревня, 4к1, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.676321, 37.470419], // TODO: Укажите [широта, долгота]
  },
  '5831ДС_Немч_1-яЗапрудная26': {
    address: '1-я Запрудная улица, 26А, село Немчиновка, Одинцовский городской округ, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.723866, 37.367993], // TODO: Укажите [широта, долгота]
  },
  '5831ДС_Немчиновка_1-яЗапрудная 26': {
    address: '1-я Запрудная улица, 26А, село Немчиновка, Одинцовский городской округ, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.723866, 37.367993], // TODO: Укажите [широта, долгота]
  },
  '5834ДС_Мира64': {
    address: 'проспект Мира, 64, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.786040, 37.635844], // TODO: Укажите [широта, долгота]
  },
  '5848ДС_Ленинский54': {
    address: 'Ленинский проспект, 54, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.697874, 37.560395], // TODO: Укажите [широта, долгота]
  },

  '5910ДС_Люб_Новая9': {
    address: 'Новая улица, 9, Люберцы, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.693099, 37.871553], // TODO: Укажите [широта, долгота]
  },
  '5921ДС_Ткацкая5': {
    address: 'Ткацкая улица, 5, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.786151, 37.723178], // TODO: Укажите [широта, долгота]
  },
  '5929ДС_Красн_Центральная68': {
    address: 'Центральная улица, 68Вс1, Красногорск, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.811948, 37.354204], // TODO: Укажите [широта, долгота]
  },
  '5955ДС_Мыт_Станционная7': {
    address: 'Станционная улица, 7, Мытищи, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.914564, 37.757296], // TODO: Укажите [широта, долгота]
  },
  '5980ДС_1-яМагистральная18': {
    address: '1-я Магистральная улица, 18с1, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.771525, 37.518605], // TODO: Укажите [широта, долгота]
  },
  '5981ДС_Лухманская37': {
    address: 'Лухмановская улица, 37, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.724824, 37.910756], // TODO: Укажите [широта, долгота]
  },
  '6028ДС_Покровский3': {
    address: 'Покровский бульвар, 3с7, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.757278, 37.648888], // TODO: Укажите [широта, долгота]
  },
  '6028ДС_Покровский бульвар 3': {
    address: 'Покровский бульвар, 3с7, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.757278, 37.648888], // TODO: Укажите [широта, долгота]
  },
  '6036ДС_СтарыйГай8': {
    address: 'улица Старый Гай, 8, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.740309, 37.828650], // TODO: Укажите [широта, долгота]
  },
  '6097ДС_Академика Глушко 15': {
    address: 'улица Академика Глушко, 15, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.565666, 37.560448], // TODO: Укажите [широта, долгота]
  },

  '6097ДС_АкадемикаГлушко15': {
    address: 'улица Академика Глушко, 15, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.565666, 37.560448], // TODO: Укажите [широта, долгота]
  },
  '6098ДС_Несвижский2': {
    address: 'Несвижский переулок, 2, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.732002, 37.587569], // TODO: Укажите [широта, долгота]
  },
  '6098ДС_Несвижский переулок 2': {
    address: 'Несвижский переулок, 2, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.732002, 37.587569], // TODO: Укажите [широта, долгота]
  },
  '6571ДС_Каховка20': {
    address: 'улица Каховка, 20А, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.658393, 37.567204], // TODO: Укажите [широта, долгота]
  },
  '6694ДС_Наметкина 3': {
    address: 'улица Намёткина, 3, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.666056, 37.545824], // TODO: Укажите [широта, долгота]
  },
  '6694ДС_Наметкина3': {
    address: 'улица Намёткина, 3, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.666056, 37.545824], // TODO: Укажите [широта, долгота]
  },
  // TODO: Закончил тут!
  '6737ДС_Мыт_Волковское23': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '6783ДС_Береговой4': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '6783ДС Береговой проезд, 4/6с1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '6836ДС_Щел_Фряновское1': {
    address: 'Фряновское шоссе, 1, Щёлково, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.928113, 38.008070], // TODO: Укажите [широта, долгота]
  },

  '6850ДС_Зел_2й Западный пр 2': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '6859ДС_Соколово-Мещерская40': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '6965ДС_7яКожуховская9': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7087ДС_Ббр_239': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7149ДС_Сер_5-ЯБорисовская16': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7164ДС_Чермянская5': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7192ДС_Ивнт_Железнодорожная11': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7266ДС_Варшавское95': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7271М_Пут_СпасоТушинский3': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7290ДС_Кор_Тихонравова11': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '7315ДС_Профсоюзная152': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7316ДС_Бирюлевская 47': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7316ДС_Бирюлевская47': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7327ГС_ННов_Мещерский7': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7352ДС_Реут_Победы31': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7368ДС_9-яПарковая62': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7369ДС_Выборгская 16': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7394ДС_Нижегородская32': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7406ДС_Венёвская 4': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7406ДС_Венёвская4': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '7450ДС_Вернадского37': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7461ДС_Новочеркасский10': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7482ДС_АкадемикаКоролева13': {
    address: 'улица Академика Королёва, 13, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.820961, 37.618893], // TODO: Укажите [широта, долгота]
  },
  '7498ДС_Фабрициуса18': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7626ДС_Гончарова17': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7677ВГ_Ленинградский36': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7787ДС_Пут_ МКАД71км16': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '7797ДС_Том_ЕгорьевскогоШоссе2-йкм1': {
    address: 'Егорьевское шоссе, 2-й километр, 1, посёлок городского типа Томилино, городской округ Люберцы, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.658972, 37.929575], // TODO: Укажите [широта, долгота]
  },
  '7901ДС_Смольная34': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8025М_Волоколамское14переезд': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '8042ДС_Иркутская7': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8065ДС_Берзарина21': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8072ДС_Под_Профсоюзная1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8079ДС_Мыт_Фабричная17': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8092ДС_Садовая-Триумфальная22': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8096ДС_Люб_Некрасовский4': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8110ДС_Нагатинская 16': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8110ДС_Нагатинская16': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8136ДС_Кот_2-йПокровский11': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8136ДС_Кот_2йПокровский11': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '8145ДС_КоровийВал1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8168ДС_Апр_Дубки1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8175ДС_Снежная27': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8202ДС_Бал_Южная13': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8253ДС_Барболина2': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8256М_Живописная12': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8289ДС_Дом_Набережная12': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8317ДС_Волгоградский73': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8319ДС_Хлобыстова3': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8320ДС_Внуковское_30кв-л1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '8329М_МаршалаВасилевского17': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8347ДС_Тарычево_5': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8353ДС_Один_Можайское121': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8386ДС_Литовский22': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8396ДС_Чех_Симферопольское1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8417ОС_МаршалаПрошлякова5': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8417ОС_Маршала Прошлякова, д. 5А стр. 5': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8443ДС_Зеленый3': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8464ДС_БольшаяЧеремушкинская2': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8479ДС_Боровское6': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '5488, Лыткарино, Колхозная 96': {
    address: 'Колхозная улица, 96А, Лыткарино, Московская область', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.582187, 37.892169], // TODO: Укажите [широта, долгота]
  },

  '8483ДС_Автозаводская 24': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8548ДС_Миклухо-Маклая 18': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8548ДС_Миклухо-Маклая18': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8557ДС_6-яНововатутинская2': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8578ДС_Малыгина9': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8654ДС Генерала Белобородова 11': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8678ОС_Кор_Калининградская5Сервисы': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8776ДС_Дми_БирловоПоле30': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8781ДС_Римского-Корсакова 11': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8791ДС_Бал_Энтузиастов39': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '8877ДС_Симферопольское14': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8889ДС_ЛиповыйПарк1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8917ДС_1-яИзмайловскогоЗверинца8': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8918 ДС_Пяловская д1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8958ДС_3я Парковая 55': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8993ДС_Тишинская1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8995ДС_Дом_Талалихина41': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8999ДС_ Большая Тульская 2': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '8999ДС_БольшаяТульская2': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '9027ДС_ЛинииОктябрьскойЖелезнойДороги2': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },

  '9035 ДС_Зеленоград, Панфиловский пр-кт, к 1841': {
    address: 'Панфиловский проспект, к1841, Зеленоград, Москва', // TODO: Укажите человекочитаемый адрес
    coordinates: [55.977758, 37.166106], // TODO: Укажите [широта, долгота]
  },
  '9038ДС_Сол_Почтовая27': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '9048ДС_Под_АкадемикаДоллежаля3': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  '9108ДС_Вильнюсская1': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  'Кулакова (офис Строгино+ Магазин Кафе)': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
  'Объект: 6036ДС_СтарыйГай8': {
    address: '', // TODO: Укажите человекочитаемый адрес
    coordinates: [], // TODO: Укажите [широта, долгота]
  },
};

// Функция для получения данных адреса по техническому адресу
export const getAddressData = (technicalAddress) => {
  if (!technicalAddress) return null;

  // Попробуем найти точное совпадение
  if (addressMapping[technicalAddress]) {
    return addressMapping[technicalAddress];
  }

  // Если не нашли, вернем null
  return null;
};
